<template>
  <div class="needle-autocomplete" :class="{'hasresults': showResults}">
    <div class="needle-autocomplete__box">
      <input placeholder="Reiseziel, Hotelname, TV-Bestellnummer"
             id="search-needle"
             class="needle-input"
             @input="search"
             @keydown.up="up"
             @keydown.down="down"
             @keydown.esc="reset"
             @keydown.enter="submit"
             @focus="focus"
             @blur="blur"
             type="text"
             tabindex="1"
             autocomplete="off"
             v-model="searchObj.Needle">
      <span v-show="!hasResults"
            class="autocomplete__icon autocomplete--magnifier"
            @click="reset">
        <i class="fa fa-search"></i>
      </span>
      <span v-show="hasResults"
            class="autocomplete__icon autocomplete--clear"
            @click="reset">
        x
      </span>
      <span v-show="hasResults"
            class="autocomplete__icon autocomplete--search"
            @click="submit">
        suchen
      </span>
    </div>
    <ul v-show="results" class="autocomplete__results">
      <slot name="results">

        <ul v-if="searchResults.locations.length > 0" class="grouped">
          <li class="autocomplete__results__header">Orte</li>
          <li v-for="location in searchResults.locations" class="autocomplete__results__item">
            <needle-item-location v-bind:item="location" v-bind:needle="searchObj.Needle"/>
          </li>
          <li v-if="searchResults.moreLocations" class="autocomplete__results__item">
            <div class="container" @mousedown="moreRegions">
              <div class="text-all">
                <p class="headline mt-orange mb-0"
                   title="Alle TV-Angebote und Videos mit ihrem Suchbegriff anzeigen">
                  Alle <i class="fa fa-hotel"></i> TV-Angebote und <i class="fa fa-tv"></i>
                  Videos mit "<b>{{ searchObj.Needle }}</b>" anzeigen
                </p>
              </div>
            </div>
          </li>
        </ul>

        <ul v-if="searchResults.euvias.length > 0" class="grouped">
          <li class="autocomplete__results__header">TV-Angebote</li>
          <li v-for="euvia in searchResults.euvias" class="autocomplete__results__item">
            <needle-item-euvia v-bind:item="euvia" v-bind:needle="searchObj.Needle"/>
          </li>
          <li v-if="searchResults.moreEuvias" class="autocomplete__results__item">
            <div class="container" @mousedown="moreEuvias">
              <div class="text-all">
                <p class="headline mt-orange mb-0"
                   title="Alle TV-Angebote mit ihrem Suchbegriff anzeigen.">
                  Alle <i class="fa fa-hotel"></i> TV-Angebote mit "<b>{{ searchObj.Needle }}</b>" anzeigen
                </p>
              </div>
            </div>
          </li>
        </ul>

        <ul v-if="searchResults.videos.length > 0" class="grouped">
          <li class="autocomplete__results__header">Videos</li>
          <li v-for="video in searchResults.videos" class="autocomplete__results__item">
            <needle-item-video v-bind:item="video" v-bind:needle="searchObj.Needle"/>
          </li>
          <li v-if="searchResults.moreVideos" class="autocomplete__results__item">
            <div class="container" @mousedown="moreVideos">
              <div class="text-all">
                <p class="headline mt-orange mb-0"
                   title="Alle Videos mit ihrem Suchbegriff anzeigen">
                  Alle <i class="fa fa-tv"></i> Videos mit "<b>{{ searchObj.Needle }}</b>" anzeigen
                </p>
              </div>
            </div>
          </li>
        </ul>
        <ul class="grouped">
          <!-- no results -->
          <li v-if="noResultMessage"
              class="autocomplete__results__item autocomplete__no-results">
            No Results.
          </li>
          <li v-else
              class="autocomplete__results__item">
            <div class="container" @mousedown="submit">
              <div class="icon"></div>
              <div class="text">
                <p class="headline mt-orange text-right"
                   title="Alle Ergebnisse anzeigen">
                  Alle Ergebnisse zu "<b>{{ searchObj.Needle }}</b>" anzeigen
                </p>
              </div>
              <div class="arrow"><i class="fa fa-chevron-right"></i></div>
            </div>
          </li>
        </ul>
      </slot>
    </ul>
  </div>
</template>

<script>
import SearchObject from "../SearchObject";
import Results from "../Results";
import NeedleItemEuvia from "./Needle/ItemEuvia.vue";
import NeedleItemVideo from "./Needle/ItemVideo.vue";
import NeedleItemLocation from "./Needle/ItemLocation.vue";

import axios from 'redaxios/dist/redaxios';
import debounce from 'lodash/debounce';

export default {
  name: "Needle",
  components: {
    NeedleItemEuvia,
    NeedleItemVideo,
    NeedleItemLocation
  },
  data() {
    return {
      error: null,
      eventListener: false,
      isFocussed: false,
      loading: false,
      searchObj: new SearchObject(),
      searchResults: new Results(),
      results: [],
      selectedId: null,
      selectedIndex: null,
      showResults: false,
      value: null,
      xhr: null,
      maxItems: 2,
      minSearchChars: 2
    };
  },
  methods: {
    search: debounce(function () {
      if (this.searchObj.Needle.length < this.minSearchChars) {
        this.results = [];
        this.showResults = false;
        this.searchObj.resetRegion();
        return;
      }
      this.requestApi();
    }, 250),
    async requestApi() {
      self = this;
      await axios.post(
          "/suggest-proxy.php",
          JSON.stringify(this.searchObj.apiSuggestObject()),
          {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          })
          .then(response => {
            this.results = this.transformResponse(response.data);
            if (this.results.length)
              this.showResults = true;
          })
          .catch(error => {
            console.log('🌞', error)
          });
    },
    transformResponse: function (data) {
      let tmpData = data.Items || [],
          euvia = [],
          video = [],
          location = [];

      self.searchResults.reset();

      for (let i = 0; i < tmpData.length; i++) {
        if (tmpData[i].Type === 'undefined')
          continue;

        switch (tmpData[i].Type) {
          case 'euvia':
            if (euvia.length >= self.maxItems) {
              self.searchResults.moreEuvias = true;
              continue;
            }
            euvia.push(tmpData[i]);
            self.searchResults.appendEuvia(tmpData[i]);
            break;
          case 'video':
            if (video.length >= self.maxItems) {
              self.searchResults.moreVideos = true;
              continue;
            }
            video.push(tmpData[i]);
            self.searchResults.appendVideo(tmpData[i]);
            break;
          case 'country':
          case 'region':
          case 'subRegion':
            if (location.length >= self.maxItems) {
              self.searchResults.moreLocations = true;
              continue;
            }
            location.push(tmpData[i]);
            self.searchResults.appendLocation(tmpData[i]);
            break;
        }
      }
      return [...location, ...euvia, ...video];
    },
    up() {
      if (this.selectedIndex === null) {
        this.selectedIndex = this.results.length - 1;
        return;
      }
      this.selectedIndex = (this.selectedIndex === 0) ? this.results.length - 1 : this.selectedIndex - 1;
    },
    down() {
      if (this.selectedIndex === null) {
        this.selectedIndex = 0;
        return;
      }
      this.selectedIndex = (this.selectedIndex === this.results.length - 1) ? 0 : this.selectedIndex + 1;
    },
    focus() {
      this.isFocussed = true;
    },
    blur() {
      this.isFocussed = false;
      this.showResults = false;
    },
    reset() {
      this.results = [];
      this.showResults = false;
      this.searchObj.Needle = '';
      this.searchObj.resetRegion();
    },
    open(obj) {
      this.searchObj.openWindow(obj);
    },
    enter() {
      this.results = [];
      this.showResults = false;
    },
    select() {
      this.open(this.results[this.selectedIndex]);
    },
    submit() {
      this.searchObj.Type = ["euvia", "video"]; // exclude "region" here not needed for result page
      this.searchObj.hideTypeFilter = false;
      this.$parent.$parent.$parent.$data.showOverlay = true;
      setTimeout(() => this.$parent.$refs.form.submit(), 250);
    },
    moreEuvias() {
      this.searchObj.Type = ["euvia"];
      this.searchObj.hideTypeFilter = true;
      this.$parent.$parent.$parent.$data.showOverlay = true;
      setTimeout(() => this.$parent.$refs.form.submit(), 250);
    },
    moreVideos() {
      this.searchObj.Type = ["video"];
      this.searchObj.hideTypeFilter = true;
      this.$parent.$parent.$parent.$data.showOverlay = true;
      setTimeout(() => this.$parent.$refs.form.submit(), 250);
    },
    moreRegions() {
      this.searchObj.Type = ["region"];
      this.$parent.$parent.$parent.$data.showOverlay = true;
      setTimeout(() => this.$parent.$refs.form.submit(), 250);
    }
  },
  computed: {
    noResultMessage() {
      if (this.results.length === 0 && this.searchObj.Needle.length >= this.minSearchChars) {
        return true;
      }
      return false;
    },
    hasResults() {
      return this.results.length;
    }
  },
};
</script>

<style lang="scss">
</style>